"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InStores = void 0;
const Address_1 = require("./instores/Address");
const BusinessConcepts_1 = require("./instores/BusinessConcepts");
const ContactEmail_1 = require("./instores/ContactEmail");
const Name_1 = require("./instores/Name");
const SellingCountries_1 = require("./instores/SellingCountries");
const StoreCategory_1 = require("./instores/StoreCategory");
const StoreId_1 = require("./instores/StoreId");
const SupportEmail_1 = require("./instores/SupportEmail");
const SupportPhone_1 = require("./instores/SupportPhone");
exports.InStores = {
    address: Address_1.Address,
    business_concepts: BusinessConcepts_1.BusinessConcepts,
    contact_email: ContactEmail_1.ContactEmail,
    name: Name_1.Name,
    selling_countries: SellingCountries_1.SellingCountries,
    store_category: StoreCategory_1.StoreCategory,
    store_id: StoreId_1.StoreId,
    support_email: SupportEmail_1.SupportEmail,
    support_phone: SupportPhone_1.SupportPhone,
};
